export const en = {
    'experiments-archive-message-multiply':
        '{experimentsList} were archived in Yandex.Audience. Exclude the archived experiments from the list of active experiments.',
    'experiments-archive-message-single':
        '{experimentsList} was archived in Yandex.Audience. Exclude the archived experiment from the list of active experiments.',
    'show-only-selected': 'Show selected only',
    subtitle: 'Enter a maximum of 5 experiments per campaign',
    title: 'Set up experiments'
};
